import { useMemo } from "react";

import { VirtualizedQueryResult } from "./types";

export function useQueriesTransform<T extends unknown[], R>(
  queries: [...{ [K in keyof T]: VirtualizedQueryResult<T[K]> }],
  transform: (...data: T) => R,
): VirtualizedQueryResult<R> {
  const data = useMemo(
    () => transform(...(queries.map((query) => query.data) as T)),
    [queries, transform],
  );

  const result = useMemo(() => {
    const isLoading = queries.some((query) => query.isLoading);
    const isError = !isLoading && queries.some((query) => query.isError);
    const isSuccess = !isLoading && queries.every((query) => query.isSuccess);
    return {
      isLoading,
      isError,
      isSuccess,
      data,
    };
  }, [queries, data]);

  return result;
}
